import { ArrowRight } from "lucide-react";
import { formatBitcoin } from "@/lib/utils";

interface TransactionSummaryProps {
  inputCount: number;
  outputCount: number;
  inputTotal: number;
  outputTotal: number;
}

export default function TransactionSummary({ 
  inputCount, 
  outputCount, 
  inputTotal, 
  outputTotal 
}: TransactionSummaryProps) {

  return (
    <div className="space-y-4">
      {/* Inputs/Outputs Count Section */}
      <div className="grid grid-cols-2 gap-4">
        <div className="flex items-center">
          <ArrowRight className="h-5 w-5 mr-3 text-blue-600 dark:text-blue-400" />
          <div>
            <p className="text-sm font-medium text-slate-900 dark:text-white">Inputs</p>
            <span className="text-sm text-slate-600 dark:text-gray-400">
              {inputCount.toLocaleString()}
            </span>
          </div>
        </div>

        <div className="flex items-center">
          <ArrowRight className="h-5 w-5 mr-3 text-blue-600 dark:text-blue-400" />
          <div>
            <p className="text-sm font-medium text-slate-900 dark:text-white">Outputs</p>
            <span className="text-sm text-slate-600 dark:text-gray-400">
              {outputCount.toLocaleString()}
            </span>
          </div>
        </div>
      </div>

      {/* Input/Output Totals */}
      <div className="space-y-3">
        <div className="flex items-center">
          <ArrowRight className="h-5 w-5 mr-3 text-blue-600 dark:text-blue-400" />
          <div className="flex-1">
            <p className="text-sm font-medium text-slate-900 dark:text-white">Input Total</p>
            <div className="flex items-center">
              <span className="text-sm text-slate-600 dark:text-gray-400">
                {formatBitcoin(inputTotal / 1e8)} BTC
              </span>
            </div>
          </div>
        </div>

        <div className="flex items-center">
          <ArrowRight className="h-5 w-5 mr-3 text-blue-600 dark:text-blue-400" />
          <div className="flex-1">
            <p className="text-sm font-medium text-slate-900 dark:text-white">Output Total</p>
            <div className="flex items-center">
              <span className="text-sm text-slate-600 dark:text-gray-400">
                {formatBitcoin(outputTotal / 1e8)} BTC
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 